import { Controller } from "@hotwired/stimulus"

// Click-to-seek for the replay chapter list. Supports HTML5 <video> directly
// (sets currentTime) and YouTube iframes (uses postMessage seekTo). Anything
// else falls back to no-op.
export default class extends Controller {
  static targets = ["video", "iframe"]

  seek(event) {
    const at = Number(event.params?.at || event.currentTarget?.dataset?.replayChaptersAtParam || 0)
    if (!Number.isFinite(at) || at < 0) return

    if (this.hasVideoTarget) {
      try { this.videoTarget.currentTime = at; this.videoTarget.play().catch(() => {}) } catch (_) {}
      return
    }
    if (this.hasIframeTarget && this.iframeTarget.contentWindow) {
      // Restrict the target origin to YouTube's known embed domains so a
      // hijacked / replaced iframe can't intercept the message. Falls back
      // to the iframe's actual origin parsed from src for non-YouTube embeds.
      const origin = this._iframeOrigin()
      this.iframeTarget.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "seekTo", args: [at, true] }),
        origin
      )
      this.iframeTarget.contentWindow.postMessage(
        JSON.stringify({ event: "command", func: "playVideo", args: [] }),
        origin
      )
    }
  }

  _iframeOrigin() {
    try {
      const src = this.iframeTarget.src || ""
      const u = new URL(src, window.location.href)
      // Only trust YouTube origins for postMessage to avoid sending control
      // commands to attacker-controlled domains.
      if (/(^|\.)youtube(-nocookie)?\.com$/.test(u.hostname)) {
        return u.origin
      }
    } catch (_) { /* invalid URL */ }
    return "https://www.youtube.com"
  }
}
